import { RoomSelectMasterTranslator } from 'src/translators/RoomSelectMasterTranslator'
import { useGetSelectsQuery } from 'src/types/generated'

type Input = {
  projectId: string
  roomId: string
}

/** 住戸に紐づくセレクト設問一覧取得 */
export const useGetSelects = ({ projectId, roomId }: Input) => {
  const { loading, data, error, refetch } = useGetSelectsQuery({
    variables: { projectId, roomId: Number(roomId) },
    fetchPolicy: 'network-only',
  })

  return {
    loading,
    selects:
      data && data.selects && data.selects.selects
        ? RoomSelectMasterTranslator.toEntities({
            projectId,
            responses: data.selects.selects,
          })
        : [],
    error,
    refetch,
  }
}
